export default __webpack_public_path__ + "static/business-intelligence-data-analysis-cover-2b798bc0167df9020d6a5619628a3e6f.jpg";